/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/31
 * @updateTime 2021/8/31
 * @decription
 */
import InfoTitle from '@/components/common/InfoTitle';
// 表单布局
import acLayoutForm from '@/components/app/layout/form/index.vue';
// 选择法院组件
import acSelectCourt from '@/components/app/select-court/index.vue';
// 滑动操作单元格组件
import ccSwipeCellRightDelete from '@/components/common/swipe-cell-right-delete/index.vue';
import validate from '@/utils/validator/validator';
import {
    fySqsRule,
    SfzmlclRule,
    fyZjRule,
    fysqrRule
} from '@/utils/validator/rules';
// 请求js
import request from './request.js';
// 基本信息
import basic from '../mixins/basic.js';
// 申请人相关的操作js
import sqr from './sqr.js';
// 代理人相关的操作js
import dlr from './dlr.js';
// 上传材料
import sccl from './sccl.js';
export default {
    components: {
        InfoTitle,
        acLayoutForm,
        ccSwipeCellRightDelete,
        acSelectCourt
    },
    // 混入
    mixins: [
        request,
        basic,
        sqr,
        dlr,
        sccl
    ],
    data() {
        return {
            // 基本信息表单数据
            formData: {
                // 复议id
                cId: this.$route.query.id,
                // 保全id
                cBqId: this.$route.query.bqid,
                // 申请法院id
                nSqfy:'',
                //申请法院名称
                cSqfymc: '',
                //保全案号
                cBqah: '',
                //复议事项
                nFysx: '1',
                //复议事项文字
                nFysxText: '财产保全审查的裁定',
                //案件类型
                nAjlx: '1',
                nAjlxText: '非诉',
                //提交人身份
                cTjrlx: 1,
                cTjrlxText: '申请人',
                //申请日期
                dtSqrq: this.getCurrentData(),
                //复议理由
                cFyky:'',
                cAhdm:null,
            },
            // 保全id
            bqid: this.$route.query.bqid,
            // 复议id，如果通过参数传过来，则获取参数中的id值，或者从sessionStorage中获取
            fyid: this.$route.query.id,
            // 复议申请人
            fySqr:[],
            // 复议代理人
            fyDlr:[],
            // 申请书材料
            sqs: [],
            // 身份证明类材料
            sfzml: [],
            // 证据类材料
            zjl: [],
            // 裁定书
            cds: [],
            // 其他
            qt: [],
            // 是否显示弹层
            showPopupSqr: false,
            // 是否可以渲染
            canRender: false,
            saveFlag: false
        }
    },
    created() {
        // 获取页面数据
        this.getPageData();
    },
    methods: {
        /**
         * 请求页面数据
         * @returns {void}
         * */
        getPageData() {
            // 获取基本信息
            this.getBasic(this.fyid, this.bqid);
            // 获取申请人数据
            this.sqrGetData();
            //获取代理人
            this.dlrGetData();
            //获取已上传的材料
            this.scclGetData();
        },
        //添加/编辑复议申请人
        addFySQR(fySqsId){
            if (fySqsId && fySqsId != 'undefined') {
                sessionStorage.setItem("fySqsId", fySqsId);
            } else {
                sessionStorage.setItem("fySqsId", "");
            }
            this.$router.push({
                path: "/addFySQR",
            });
        },
        //添加/编辑代理人
        addDLR(fyDlrId){
            if (fyDlrId && fyDlrId != 'undefined') {
                sessionStorage.setItem("fyDlrId", fyDlrId);
            } else {
                sessionStorage.setItem("fyDlrId", "");
            }
            this.$router.push({
                path: "/addDLR",
            });
        },

        requestTempSave() {
            // 请求暂存接口
            return this.$axios.post('ssbq/api/fy/xcx/tempsave', this.getParams());
        },
        //点击暂存按钮
        stagBtn(){
            // 请求暂存接口
            this.requestTempSave()
                .then(() => {
                    // 代理人删除id集合置空
                    this.dlrDelIds = [];
                    // 申请人删除id集合置空
                    this.sqrDelIds = [];
                    this.$notify({'type': 'success', 'message': '暂存成功'});
                    // 重新获取页面数据
                    this.getPageData();
                })
        },
        myId(i) {
            return new Promise((resolve) => {
                i++
                if (i > 3) {
                    this.$notify("系统异常");
                } else {
                    this.getId().then((res) => {
                        resolve(res.data);
                    }).catch(() => {
                        this.myId(i)
                    })
                }
            })
        },
        getId() {
            return new Promise((resolve) => {
                this.$axios.get("ssbq/api/id")
                    .then(res => {
                        if (res.code == 200) {
                            resolve(res);
                        } else {
                            this.$notify(res.message);
                        }
                    }).catch(() => {
                    this.$notify("系统异常");
                });
            });
        },

        /**
         * 获取参数
         * @returns {Object}
         * */
        getParams() {
            return {
                // 复议基本信息
                fyJbxx: this.formData,
                // 复议申请人
                fySqrs: this.sqrDataList,
                // 复议代理人
                fyDlrs: this.dlrDataList,
                // 代理人删除id集合
                dlrIds: this.dlrDelIds,
                // 申请人id集合
                sqrIds: this.sqrDelIds
            };
        },

        //点击提交
        eClickSubmit() {
            // 校验基础数据
            this.validateBasicData(this.formData).then(() => {

                console.log("zxfwtoken========", localStorage.getItem('zxfwtoken'));
                if (localStorage.getItem('zxfwtoken')) {
                    const paramsah = {
                        fydm: this.formData.nSqfy,
                        ah: this.formData.cBqah,
                        zxfwToken: localStorage.getItem('zxfwtoken')
                    };
                    this.$axios.get('ssbq/api/bqyzw/bqsq/ahdm', paramsah).then((res) => {
                        if (res.code === 200) {
                            this.formData.cAhdm = res.data;
                            console.log('——————this.cAhdm：————————', this.formData.cAhdm);
                            this.saveFlag = true;
                            console.log('——————this.saveFlag1：————————', this.saveFlag);
                            this.validateFormData().then(()=>{
                                // 校验上传材料
                                this.validateClxx().then(() => {
                                    // 先调用暂存接口，再进行提交操作
                                    this.requestTempSave().then(() => {
                                        this.$axios.put('ssbq/api/fy/fysq/tj?fyid=' + this.fyid).then(() => {
                                            this.$notify({'type': 'success', 'message': '提交复议成功'});
                                            //提交时删除保全列表的复议id
                                            sessionStorage.removeItem("currentfyid");
                                            // 路由跳转到我的复议申请列表
                                            this.$router.push("/home/myReconsider");
                                        })
                                    })
                                })
                            })
                        } else {
                            const errorMessage = '案号代码获取失败,请重新尝试';
                            this.$notify(errorMessage);
                            this.saveFlag = false;
                        }
                    });
                } else {
                    const errorMessage = '案号代码获取失败,请重新尝试';
                    this.$notify(errorMessage);
                    this.saveFlag = false;
                }
            }).catch(() => {
                console.log('请完善表单信息');
            });
            // if(this.saveFlag){
            //     // 校验申请人列表
            //     this.validateFormData().then(()=>{
            //         // 校验上传材料
            //         this.validateClxx().then(() => {
            //             // 先调用暂存接口，再进行提交操作
            //             this.requestTempSave().then(() => {
            //                 this.$axios.put('ssbq/api/fy/fysq/tj?fyid=' + this.fyid).then(() => {
            //                     this.$notify({'type': 'success', 'message': '提交复议成功'});
            //                     //提交时删除保全列表的复议id
            //                     sessionStorage.removeItem("currentfyid");
            //                     // 路由跳转到我的复议申请列表
            //                     this.$router.push("/home/myReconsider");
            //                 })
            //             })
            //         })
            //     })
            //     }
            //
            // }).catch(() => {
            //     console.log('请完善表单信息');
            // })

        },

        //校验申请人必填
        validateFormData: function () {
            let descriptor = {
                // 复议申请人规则
                fySqr: fysqrRule,
            };
            let data = {
                // 复议申请人
                fySqr: this.sqrDataList
            };
            const validated = validate(descriptor, data);
            return validated;
        },
        //验证材料上传必填项
        validateClxx() {
            let descriptor = {
                sqs: fySqsRule, // 申请书材料 必填
                sfzml: new SfzmlclRule(true), // 身份证明类材料 必填,分别校验每个申请人
                zjl: fyZjRule // 证据类材料 必填
            };
            const validated = validate(descriptor, {
                // 申请书材料 必填
                sqs: this.scclData.sqs,
                // 身份证明类材料 必填,分别校验每个申请人
                sfzml: this.scclData.sfzml,
                // 证据类材料 必填
                zjl: this.scclData.zjl
            });
            return validated
        },

        /**
         * 返回
         * @returns {void}
         * */
        back() {
            this.$router.push('/home/myReconsider');
        }
    },
    //进入该页面时，用之前保存的滚动位置赋值
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if(from.name == 'myReconsider' || from.name == 'reconsiderBasic'){
                window.location.reload();
            }
            // 可以进行渲染
            vm.canRender = true;
        })
    }
}
